import React from 'react';
export function Footer() {
  return <footer className="bg-white text-black p-8 md:p-12" data-id="element-22">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-end" data-id="element-23">
        <div data-id="element-24">
          <h2 className="text-2xl font-bold mb-4" data-id="element-25">BUTINEURJEU</h2>
          <div className="space-y-1 text-sm font-medium" data-id="element-26">
            <p data-id="element-27">WARSZAWA, POLAND</p>
            <p data-id="element-28">UL. PRZEMYSŁOWA 12/4</p>
            <a href="mailto:hello@butineurjeu.pl" className="hover:text-[#ff0000] underline decoration-1 underline-offset-4" data-id="element-29">
              HELLO@BUTINEURJEU.PL
            </a>
          </div>
        </div>

        <div className="md:text-right" data-id="element-30">
          <p className="text-sm font-medium text-gray-500" data-id="element-31">
            © 2026 BUTINEURJEU. ALL RIGHTS RESERVED.
          </p>
          <p className="text-xs mt-2 text-gray-400" data-id="element-32">
            NO COOKIES. NO TRACKING. JUST CODE.
          </p>
        </div>
      </div>
    </footer>;
}